const MOBILE_NUMBER_REGEX_PATTERN = /^(\+91[\-\s]?)?[0]?(91)?[6789]\d{9}$/;
const EMAIL_REGEX_PATTERN = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
const STRONG_PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.#$!%*?&])[A-Za-z\d@.#$!^%*?&]{8,15}$/;

const AUTH_PAGES = ['/login', '/register', '/forgot', '/reset-password'];

export const isValidEmail = (email = '') => {
  return EMAIL_REGEX_PATTERN.test(email);
}

export const isValidPhoneNumber = (phone = '') => {
  return MOBILE_NUMBER_REGEX_PATTERN.test(phone);
}

export const isStrongPassword = (password = '') => {
  return STRONG_PASSWORD_REGEX.test(password);
}

export const PASSWORD_STRENGTH = {
  1: "Very weak",
  2: "Weak",
  3: "Meduim",
  4: "Strong",
}

export const checkAuthPage = (pathname = '') => {
  return AUTH_PAGES.some((route) => pathname === route || pathname.startsWith(`${route}/`));
};

export const MIN_PAYOUT_TOKEN = 1000;

export const MIN_REQUIRED_BALANCE = 5000;
